import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import {
  ServiceDeliveryStatus,
  ServiceType
} from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { BookingServicesDto } from "../../../../features/Booking-Form/typings/booking.types";
import { UpdateServicesDto } from "../../../../hooks/Remote/Services/OrderRequests/useRemoteUpdateBookingServicesByAdmin";
import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";

export const transformOrderRequest = (
  targetBookingId: string,
  changedDeliveryStatus: ServiceDeliveryStatus,
  bookingType: BookingType,
  changes: Pick<DetailedServiceBookingData, "caterings" | "equipments" | "roomLayouts">
): UpdateServicesDto[] => {
  const catData: BookingServicesDto[] = changes.caterings.map(cat => ({
    serviceType: ServiceType.Catering,
    status: cat.status,
    serviceId: cat.serviceId,
    setUpTime: cat.setupTime,
    qty: cat.quantity, // delivery
    orderedQty: cat.orderedQty,
    availableQty: cat.availableQty
  }));
  const equipData: BookingServicesDto[] = changes.equipments.map(equip => ({
    serviceType: ServiceType.Bookable_Equipment,
    status: equip.status,
    serviceId: equip.serviceId,
    setUpTime: equip.setupTime,
    qty: equip.quantity
  }));
  const layoutData: BookingServicesDto[] = changes.roomLayouts.map(layout => ({
    serviceType: ServiceType.Room_Layout,
    status: layout.status,
    serviceId: layout.serviceId,
    setUpTime: layout.setupTime
  }));

  const updated: UpdateServicesDto[] = [
    {
      bookingId: targetBookingId,
      bookingType: bookingType,
      deliveryStatus: changedDeliveryStatus,
      servicesInfo: [...catData, ...equipData, ...layoutData]
    }
  ];

  return updated;
};
